<template>
	<div v-cloak>
		<agenda-modal ref="modalAgenda" v-on:update:data="getData($event)"></agenda-modal>
		<div class="calendar">
	        <div>
		        <div class="calendar-content" v-if="view=='M' && !loadTareas">
		        	<div v-bind:class="{'calendar-week align-items-start':true, 'week-first':index==0, 'week':index>0}" v-for="(days, index) in weeks">
		        		<a 
		        			v-bind:class="{
		        				'week-name-day':day.weekNumber==1, 
		        				'week-name-day-gray':!day.inMonth, 
		        				'calendar-day text-truncate':true, 
		        				'calendar-today':day.isToday
		        			}" 
		        			:disabled="!day.inMonth"
		        			v-for="(day, index) in days"
		        			v-on:click.prevent="addEvent(day, day.inMonth);"
		        			>
		        			<span v-if="day.weekNumber==1" v-bind:class="{'calendar-name-day':true, 'calendar-name-today':nameDayisToday(index, day.date)}">
			            		{{weekDay(index)}}
			            	</span>

			            	<a v-on:click.stop.prevent="viewDay(day.date)" href="#" v-bind:class="{'calendar-label-day':true, 'calendar-label-today':day.isToday}">
			            		{{day.label}}
			            	</a>

			            	<ul class="calendar-events">
			            		<li class="calendar-events-item" v-for="info in day.items.slice(0, 3)">
			            			<a href="#" v-on:click.stop.prevent="getEvent(info)" v-bind:class="{'d-inline text-truncate calendar-events-item-child':true, 'calendar-events-item-danger':info.ESTATUS=='C', 'calendar-events-item-info':info.ESTATUS!='C'}">
			            				<span class="calendar-eventa-hour">
				            				{{getHours(info.FECHA)}}
				            			</span>
				            			<span class="calendar-event-title">
				            				{{info.NOTAS}}
				            			</span>
			            			</a>
			            		</li>
			            		<li class="text-truncate" v-if="day.items.length>3">
			            			<a class="pl-1 more" href="#" v-on:click.stop.prevent="viewDay(day.date)">{{day.items.length-3}} más</a>
			            		</li>
			            	</ul>
			        	</a>
		        	</div>
		        </div>
		    </div>
	        <div class="day-content" v-if="view=='D'">
	        	<div class="card">
	        		<div class="card-header bg-header">
	        			<h1 id="diaModalLabel" class="modal-title title">
		        			<p class="text-capitalize m-0" style="font-size: 12px;">
		        				{{day.title}}
		        			</p>
		        			<h1 class="m-0">
		        				{{day.name}}
		        			</h1>
		        		</h1>
	        		</div>
	        		<div class="card-body p-0">
	        			<div class="list-group" v-if="!loadDay">
	        				<div v-if="itemsFilted.length==0" class="p-3">
	        					<empty icon="event_busy" title="Agrega la primera tarea." description="Al agregar una nueva tarea llevarás registro de tu día a día."></empty>
	        				</div>
							<a href="#" class="list-group-item list-group-item-action flex-column align-items-start" v-for="(item, index) in itemsFilted" v-else v-on:click.prevent="getEvent(item)">
								<div class="d-flex w-100 justify-content-between">
							  		<h5 v-bind:class="{'mb-1 text-truncate':true, 'text-black-38':item.ESTATUS=='C'}">
							  			<span>
							  				<strong>
							  					{{item.TIPO_TAREA}}
							  				</strong>
							  			</span>
							  			<span v-if="item.oportunidad">
							  				|
							  				<strong>
							  					{{item.oportunidad.DESCRIPCION_OPORTUNIDAD}}
							  				</strong>
							  			</span>
							  		</h5>
							  		<small class="text-dark">
							  			{{getHours(item.FECHA)}}
							  		</small>
								</div>
								<p v-bind:class="{'mb-0 text-truncate':true, 'text-black-38':item.ESTATUS=='C', 'text-muted':item.ESTATUS!='C'}">
									{{item.NOTAS}}
								</p>
								<p class="m-0">
									<span v-if="item.oportunidad" v-bind:class="{'text-black-38':item.ESTATUS=='C', 'text-black-50':item.ESTATUS!='C'}">
										<small v-if="item.oportunidad.vendedor">
											Vendedor: {{item.oportunidad.vendedor.NOMBRE_VENDEDOR}}
										</small>

										<small v-if="item.oportunidad.cliente">
											| Cliente: {{item.oportunidad.cliente.NOMBRE_CLIENTE}}
										</small>
									</span>
									<span class="float-right">
										<span class="badge badge-info" v-tooltip="'Abierta'" v-if="item.ESTATUS=='A'">
											Abierta
										</span>

										<span class="badge bg-danger-38" v-tooltip="'Cerrada'" v-if="item.ESTATUS=='C'">
											Cerrada
										</span>
									</span>	
								</p>
								
							</a>
						</div>
						<div v-else class="m-3">
							<center>
								<div class="loader-vue"></div>
							</center>
						</div>
	        		</div>
	        	</div>
	        </div>
	    </div>
	</div>
</template>
<script>
	export default{
		props: ['estatus', 'sucursal', 'vendedor', 'cliente', 'oportunidad', 'fecha_asignacion_ini', 'fecha_asignacion_fin', 'fecha_creacion_ini', 'fecha_creacion_fin', 'value', 'usuario'],

		data(){
			return {
				nameDays: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
				today: moment(),
				showCalendar: true,
				view: 'M',
				day: {
					name: '',
					title: '',
					items: []
				},
				tareas:[],
				
				dateContext: moment(),
				loadDay: false,
				loadTareas: true,
				cancelMessage: '',
			};
		},

		mounted(){
			this.getDay(this.dateContext);
			this.getMonth(this.dateContext);
			this.sendEvents()
		},

		watch: {
			dateContext: function(val){
				if(this.view=='D'){
					this.getDay(val);	
				}

				if(this.view=='M'){
					this.getMonth(val);
				}
			},

			value: function (value) {
				this.dateContext = value ? value: moment();
            },

            year: function(value){
            	this.$emit('updateyear', value)
            },

            month: function(value){
            	this.$emit('updatemonth', value)
            },

            viewName: function(value){
            	this.$emit('updatename', value)
            }
		},

		computed:{
			itemsFilted: function(){
				var estatus = this.estatus;
				var sucursal = this.sucursal;
				var vendedor = this.vendedor;
				var cliente = this.cliente;
				var oportunidad = this.oportunidad;

		    	return this.day.items.filter(function(item){
		    		var validation = true;

		    		if(estatus != ''){
		    			if(item.ESTATUS != estatus){
		    				validation = false;
		    			};
		    		}

		    		if(sucursal != ''){
		    			if(item.oportunidad){
		    				if(item.oportunidad.CODIGO_SUCURSAL != sucursal){
		    					validation = false;
		    				}
		    			}
		    		}

					if(vendedor != ''){
						if(item.CODIGO_VENDEDOR != vendedor){
							validation = false;
						}
					}

					if(cliente != ''){
						if(item.oportunidad){
		    				if(item.oportunidad.CODIGO_CLIENTE != cliente){
		    					validation = false;
		    				}
		    			}else{
		    				validation = false;
		    			}
					}

					if(oportunidad != ''){
						if(item.CODIGO_OPORTUNIDAD != oportunidad){
							validation = false;
						}
					}
		    		
		    		if(validation){
		    			return item;
		    		}
		    	});
			},

			tareasFilter: function(){
				var estatus = this.estatus;
				var sucursal = this.sucursal;
				var vendedor = this.vendedor;
				var cliente = this.cliente;
				var oportunidad = this.oportunidad;

		    	return this.tareas.filter(function(item){
		    		var validation = true;

		    		if(estatus != ''){
		    			if(item.ESTATUS != estatus){
		    				validation = false;
		    			};
		    		}

		    		if(sucursal != ''){
		    			if(item.oportunidad){
		    				if(item.oportunidad.CODIGO_SUCURSAL != sucursal){
		    					validation = false;
		    				}
		    			}
		    		}

					if(vendedor != ''){
						if(item.CODIGO_VENDEDOR != vendedor){
							validation = false;
						}
					}

					if(cliente != ''){
						if(item.oportunidad){
		    				if(item.oportunidad.CODIGO_CLIENTE != cliente){
		    					validation = false;
		    				}
		    			}else{
		    				validation = false;
		    			}
					}

					if(oportunidad != ''){
						if(item.CODIGO_OPORTUNIDAD != oportunidad){
							validation = false;
						}
					}
		    		
		    		if(validation){
		    			return item;
		    		}
		    	});
			},

			viewName: function(){
				var name = ''

				if(this.view == "D"){
					name = 'Día'
				}

    			if(this.view == "W"){
    				name = 'Semana'
    			}

    			if(this.view == "M"){
    				name = 'Mes'
    			}

    			if(this.view == "Y"){
    				name = 'Año'
    			}

    			if(this.view == "A"){
    				name = 'Agenda'
    			}

    			if(this.view == "X"){
    				name = '4 días'
    			}

    			return name
			},

			year: function () {
				return this.dateContext.format('Y')
		    },

		    month: function () {
		    	return this.dateContext.format('MMMM')
		    },

		    monthNumber: function(){
		    	return this.dateContext.month();
		    },

		    weeks() {
		    	this.loadTareas = true;
			    const weeks = [];
			    let monthStarted = false, monthEnded = false;
			    let monthDay = 0;
			    // Cycle through each week of the month, up to 6 total
			    for (let w = 1; w <= 6 && !monthEnded; w++) {
			      // Cycle through each weekday
			      const week = [];
			      for (let d = 1; d <= 7; d++) {
			        // We need to know when to start counting actual month days
			        if (!monthStarted && d > this.firstDayOfMonth) {
			        	// Initialize day counter
			        	monthDay = 1;
			         	// ...and flag we're tracking actual month days
			         	monthStarted = true;
			       		// Still in the middle of the month (hasn't ended yet)
			        } else if (monthStarted && !monthEnded) {
			          // Increment the day counter
			          monthDay += 1;
			        }
			        // Append day info for the current week
			        // Note: this might or might not be an actual month day
			        //  We don't know how the UI wants to display various days,
			        //  so we'll supply all the data we can
			        week.push({
			          label: monthDay ? monthDay.toString() : '',
			          number: monthDay,
			          weekdayNumber: d,
			          weekNumber: w,
			          beforeMonth: !monthStarted,
			          afterMonth: monthEnded,
			          inMonth: monthStarted && !monthEnded,
			          isToday: monthDay == this.today.date() && this.monthNumber == this.today.month() && this.year == this.today.year(),
			          isFirstDay: monthDay === 1,
			          isLastDay: monthDay === this.daysInMonth,
			          date: monthDay ? moment().year(this.dateContext.year()).month(this.dateContext.month()).date(monthDay) : '',
			          items: this.getItems(monthDay ? moment().year(this.dateContext.year()).month(this.dateContext.month()).date(monthDay) : '')
			        });

			        // Trigger end of month on the last day
			        if (monthStarted && !monthEnded && monthDay >= this.daysInMonth) {
			          monthDay = 0;
			          monthEnded = true;
			        }
			      }
			      // Append week info for the month
			      weeks.push(week);
			    }

			    this.loadTareas = false;
			    return weeks;
			},

		    daysInMonth: function () {
		        return this.dateContext.daysInMonth();
		    },

		    currentDate: function () {
		        return this.dateContext.get('date');
		    },

		    firstDayOfMonth: function () {
		        var firstDay = moment(this.dateContext).subtract((this.currentDate - 1), 'days');
		        return firstDay.weekday();
		    },

		    initialDate: function () {
		        return this.today.get('date');
		    },

		    initialMonth: function () {
		        return this.today.format('MMMM');
		    },

		    initialYear: function () {
		        return this.today.format('Y');
		    },
		},

		methods: {
			addMonth: function () {
				this.showCalendar = false;
		        if(this.view == 'M'){
		    		this.dateContext = moment(this.dateContext).add(1, 'month');
		    	}

		    	if(this.view == 'D'){
		    		this.dateContext = moment(this.dateContext).add(1, 'day');
		    	}
		    	this.showCalendar = true;
		    },

		    subtractMonth: function () {
		    	this.showCalendar = false;
		    	if(this.view == 'M'){
		    		this.dateContext = moment(this.dateContext).subtract(1, 'month');
		    	}

		    	if(this.view == 'D'){
		    		this.dateContext = moment(this.dateContext).subtract(1, 'day');
		    	}
		    	this.showCalendar = true;
		    },

		    weekDay: function(number){
		    	return this.nameDays[number];
		    },

		    nameDayisToday: function(index, dateF){
		    	var day = (this.weekDay(index)+'.');
		    	var today = moment();
		    	var date = moment(dateF);

		    	if(today.format('MM') != date.format('MM') || today.format('YYYY') != date.format('YYYY')){
		    		return false;
		    	}

		    	if(today.format('ddd') == day.toLowerCase()){
		    		return true;
		    	}

		    	return false;
		    },

		    viewDay: function(date){
		    	this.dateContext = date;
		    	this.setView('D');
		    },

		    getHours: function(date){
		    	return moment(date).format("HH:mm");
		    },

		    hoy: function(){
		    	this.dateContext = moment();
		    },

		    getItems: function(date){
		    	var dataItem = this.tareasFilter;
		    	return dataItem.filter(function(tarea){
		    		return moment(tarea.FECHA).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD');
		    	});
		    },

		    setView: function(data){
		    	this.view = data;
		    },

		    getData: function(val){
		    	this.getMonth(val);
		    	this.getDay(val);
		    },

		    sendEvents: function(){
		    	this.$emit('updateyear', this.year)
				this.$emit('updatemonth', this.month)
				this.$emit('updatename', this.viewName)
		    },

		    getMonth: function(val){
				this.loadTareas = true;

				var month = val ? moment(val).format("MM") : moment().format("MM");
				var year = val ? moment(val).format("YYYY") : moment().format("YYYY");

				var url = 'api/tareas/year/'+year+'/month/'+month;
				
				axios.get(url)
				.then(response => {
					this.tareas = response.data;
				}).catch(error => {
					console.log(error);
				}).then(()=>{
					this.loadTareas = false;
				});
			},

		    getDay: function(val){
		    	var fecha = val ? moment(val).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");

				this.day.name = moment(fecha).format('D');
				this.day.title = moment(fecha).format('dddd');
		    	
		    	var url = 'api/tareas/fecha/'+fecha;
		    	var itemsDay = [];

		    	this.loadDay = true;
		    	axios.get(url)
				.then(response => {
					this.day.items = response.data;
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loadDay = false;
				});
		    },

		    getEvent: function(val){
		    	this.$nextTick(() => {
			    	this.$refs.modalAgenda.getEvent(val)
			    });
		    },

		    addEvent: function(day, month){
		    	this.$nextTick(() => {
			    	this.$refs.modalAgenda.addEvent(day, month)
			    });
		    },
		},
	}
</script>